/**
 *
 */
import {callForDuration} from '../../utils/timing';


/**
 *
 */
const setupSiteAnnouncement = () =>
{
	const announcement = document.querySelector( '#site-announcement' );
	const closeBtn     = document.querySelector( '#site-announcement .btn-close' );

	if (announcement instanceof HTMLElement && closeBtn instanceof HTMLElement) {

		closeBtn.addEventListener( 'click', () =>
		{
			callForDuration( () => window.dispatchEvent( new Event( 'resize' ) ), 1500 );
			announcement.classList.add( 'closed' );
		} );

		setMaxHeight( announcement );
		window.addEventListener( 'resize', () => setMaxHeight( announcement ) );
	}
};


/**
 *
 * @param {HTMLElement} announcement
 */
const setMaxHeight = ( announcement: HTMLElement ) =>
{
	if (!announcement.classList.contains( 'closed' )) {
		announcement.style.maxHeight = 'none';
		announcement.style.maxHeight = `${announcement.offsetHeight}px`;
	}
};


/**
 *
 */
export default setupSiteAnnouncement;